// Connection State

import React from 'react';
import { HiStatusOffline, HiStatusOnline } from 'react-icons/hi';
import './styles.scss';

type ConnectionStateProps = {
  isConnected: boolean;
}

const ConnectionState = ({ isConnected }: ConnectionStateProps) => {
  return (
    <div
      title={isConnected ? 'Connected' : 'Not Connected'}
      className={`connection-state ${isConnected ? 'connected' : 'not-connected'}`}
    >
      {
        isConnected ? <HiStatusOnline/> : <HiStatusOffline/>
      }
    </div>
  );
}

export default ConnectionState;
